export default "/react/logoDomino-71fd83e9.png";